<script>
import THelp from '~/components/THelp';

export default {
  extends: THelp,

  props: {
    labelKey: {
      type: String,
      required: false,
      default: 'help.applicant_date_of_birth',
    },
  },
};
</script>
